module.exports = __webpack_public_path__ + "static/media/landing-page-crop.20e86c30.png";